import React from 'react';
import { Building2, Shield, Eye, Edit, Trash2, Settings } from 'lucide-react';

const PermissionSummary = ({ permissions, companies, className = '' }) => {
  const getPermissionIcon = (permission) => {
    if (permission.includes('view')) return Eye;
    if (permission.includes('edit') || permission.includes('create')) return Edit;
    if (permission.includes('delete')) return Trash2;
    if (permission.includes('manage')) return Settings;
    return Settings;
  };

  const getPermissionColor = (permission) => {
    if (permission.includes('view')) return 'text-blue-600';
    if (permission.includes('edit') || permission.includes('create')) return 'text-green-600';
    if (permission.includes('delete')) return 'text-red-600';
    if (permission.includes('manage')) return 'text-purple-600';
    return 'text-gray-600';
  };

  const getCompanyName = (companyId) => {
    const companyNames = {
      1: 'MOV Fibra',
      2: 'XT Fibra',
      3: 'MOV Fit',
      'group': 'Grupo (Todas as empresas)'
    };
    return companyNames[companyId] || `Empresa ${companyId}`;
  };

  if (!permissions || !Array.isArray(permissions) || permissions.length === 0) {
    return (
      <div className={`p-4 bg-gray-50 border border-gray-200 rounded-lg ${className}`}>
        <p className="text-gray-500 text-sm">Nenhuma permissão configurada</p>
      </div>
    );
  }

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Empresas */}
      {companies && companies.length > 0 && (
        <div>
          <h4 className="text-sm font-medium text-gray-900 mb-2 flex items-center">
            <Building2 className="h-4 w-4 mr-2" />
            Acesso por Empresa
          </h4>
          <div className="flex flex-wrap gap-2">
            {companies.map((companyId) => (
              <span
                key={companyId}
                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
              >
                {getCompanyName(companyId)}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Permissões */}
      <div>
        <h4 className="text-sm font-medium text-gray-900 mb-2 flex items-center">
          <Shield className="h-4 w-4 mr-2" />
          Permissões ({permissions.length})
        </h4>
        <div className="space-y-1">
          {permissions.map((permission) => {
            const IconComponent = getPermissionIcon(permission);
            const iconColor = getPermissionColor(permission);
            
            return (
              <div key={permission} className="flex items-center space-x-2 text-sm">
                <IconComponent className={`h-3 w-3 ${iconColor}`} />
                <span className="text-gray-700">{permission}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* Resumo */}
      <div className="pt-2 border-t border-gray-200">
        <p className="text-xs text-gray-500">
          <strong>Total:</strong> {permissions.length} permissões em {companies?.length || 0} empresa(s)
        </p>
      </div>
    </div>
  );
};

export default PermissionSummary;

